import { ActionTree } from "vuex";
import {
	ManualActionState,
	ManualPulseRequest,
	ManualResetRequest,
} from "./types";
import { RootState } from "@/store/types";
import api from "@/services/api.service";

export const actions: ActionTree<ManualActionState, RootState> = {
	async setManualPulseData({ commit }, data: ManualPulseRequest) {
		commit("setManualPulseData", data);
	},

    async setManualEventResetData({ commit }, data: ManualResetRequest) {
		commit("setManualEventResetData", data);
	},

	async eventQuickControl(context, data: ManualResetRequest): Promise<any> {
		const { response } = await api.cCureResetNonEventAction(data, data.regionUrl);
		return response;
	}
};